<div class="col-12 text-center" *ngIf="alertIcon">
  <em class="bi bi-exclamation-circle text-warning"></em>
</div>
<div class="modal-header border-0">
  <div class="d-flex w-100">
    <div class="col text-center">
      <strong class="fs-4 {{classHeader}}">{{title}}</strong>
    </div>
    <button type="button" class="btn-close" *ngIf="!alertIcon" (click)="modalRef.hide()"></button>
  </div>
</div>
<div class="modal-body">
  <div class="col col-12 text-center mb-4" [innerHTML]="msg"></div>
</div>
<div class="row justify-content-center">
  <button type="button" *ngIf="!hiddenCancel" class="col col-12 col-md-5 col-lg-auto btn btn-outline-dark"
    data-dismiss="modal" (click)="onClose()">{{txtCancel}}</button>
  <button type="button" class="col col-12 col-md-5 col-lg-auto my-3 my-md-0 btn btn-primary"
    (click)="onConfirm()">{{txtOk}}</button>
</div>
<div class="row justify-content-center my-3">
  <span *ngIf="txtLink" class="btn" (click)="onLink()">{{txtLink}}</span>
</div>